import React, { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ContentWrapper } from '../../components/containers'
import { AdminUsersSearchBar } from '../../components/molecules/Users'
import { IUserDetailForAdmin } from '../../dto/user/user-details-for-admin.dto'
import { useUserListForAdmin } from '../../hooks/Users'
import { withLayout } from '../../hocs/withLayout'
import { withAuth } from '../../hocs'
import { DataTable } from './data-table'
import { columns } from './columns'
import { UserRoleEnum, UserStatusEnum } from '@/enums'
import { PageTitle } from '@/components'

export const UserDetailsForAdmin: FC<any> = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        status,
        data,
        fetchData,
        approveUserRequest,
        denyUserRequest,
        addRoleRequest,
        removeRoleRequest,
        cleanData,
        currentPage,
        totalPages,
        itemsPerPage
    } = useUserListForAdmin();

    const onApprove = async (e: any, user: IUserDetailForAdmin) => {
        await approveUserRequest(user.id);
    }

    const onDeny = async (e: any, user: IUserDetailForAdmin) => {
        await denyUserRequest(user.id);
    }

    const onAddRole = async (role: UserRoleEnum, user: IUserDetailForAdmin) => {
        await addRoleRequest(user.id, role);
    }

    const onRemoveRole = async (role: UserRoleEnum, user: IUserDetailForAdmin) => {
        await removeRoleRequest(user.id, role);
    }

    useEffect(() => {
        if (status !== 'none' && status !== 'fetched') {
            return;
        }
        const page = Number(searchParams.get('page') || 1);
        const searchTerm = searchParams.get('search') || '';
        const statusParam = searchParams.get('status') as UserStatusEnum || undefined;

        fetchData({
            page: page,
            search: searchTerm,
            status: statusParam
        });
        return () => {
            cleanData();
        }
    }, [searchParams]);

    return (
        <div className="flex-wrap">
            <ContentWrapper className="pt-8">
                <PageTitle title='Gestión de usuarios' />
                <div className="my-4">
                    <AdminUsersSearchBar
                        searchTerm={searchParams.get('search') || undefined}
                        status={searchParams.get('status') as UserStatusEnum || undefined}
                        onSearchChanged={(filter) => {
                            setSearchParams((prev) => {
                                let newParams = new URLSearchParams(prev);
                                if (filter.searchTerm) {
                                    newParams.set('search', filter.searchTerm);
                                } else {
                                    newParams.delete('search');
                                }
                                if (filter.status && (filter.status as string) !== '*') {
                                    newParams.set('status', filter.status);
                                } else {
                                    newParams.delete('status');
                                }
                                if (newParams != prev) {
                                    newParams.delete('page');
                                }
                                return newParams;
                            });
                        }}
                    />
                </div>

                <div className="w-full">
                    <DataTable
                        columns={columns({ onApprove, onDeny, onAddRole, onRemoveRole })}
                        data={data}
                        isLoading={status === "none" || status === "fetching"}
                        currentPage={currentPage}
                        pageCount={totalPages}
                        onPageChange={(pageIndex) => {
                            setSearchParams((prev) => {
                                prev.set('page', String(pageIndex))
                                return prev
                            })
                        }}
                        pageSize={itemsPerPage}
                    />
                </div>
            </ContentWrapper>
        </div >
    )
}

export const UserDetailsForAdminPage = withLayout(withAuth(UserDetailsForAdmin, { adminOnly: true }))
